import React, {memo} from 'react';
import useStyles from './useStyles';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import {DatePicker as MuiDateDatePicker} from '@mui/x-date-pickers/';

export const DatePicker = memo((props) => {

    const classes = useStyles()

    const {
        label,
        value,
        onChangeCallback = () => {},
        onAcceptCallback = () => {},
        fullWidth,
        size,
        variant,
        ...other
    } = props

    const dateChangeHandler = (e)=> {
        const newDate = new Date(e._d.valueOf())
        onChangeCallback?.(newDate)
        onAcceptCallback?.(newDate)
    }

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="ru">
            <MuiDateDatePicker
                onChange={dateChangeHandler}
                value={moment(value)}
                defaultValue={moment(value)}
                {...{label}}
                slotProps={{ textField: { size: 'small', variant:"standard" } }}
                fullWidth={fullWidth}
                size={size}
                variant={variant}
                className={classes.data}
                {...other}
            />
        </LocalizationProvider>
    )
})
